import React, { useState, useEffect } from "react";
import styles from "./emailVerification.module.css";

// Material Ui Icons
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CancelIcon from "@material-ui/icons/Cancel";
import CircularProgress from "@material-ui/core/CircularProgress";

// Redux stuff
import { connect } from "react-redux";
import {
    verifyEmail,
    resendVerificationEmail,
} from "../../redux/actions/providerActions";

// @ts-check

/**
 * Component for Email Verification Success/Failure Message
 * @component
 */

const EmailVerification = (props) => {
    const [success, setSuccess] = useState("");
    const { emailJwtToken } = props.match.params;

    useEffect(() => {
        props.verifyEmail(emailJwtToken, setSuccess);
    }, []);

    const resendVerificationEmail = () => {
        const data = {
            jwt: emailJwtToken,
        };
        props.resendVerificationEmail(data);
    };

    const { loading } = props.provider;

    return (
        <div className={styles.container}>
            <header className={styles.headerContainer}>👋 User</header>
            {loading ? (
                <CircularProgress />
            ) : (
                <>
                    {success && (
                        <div className={styles.message}>
                            <div>
                                <CheckBoxIcon className={styles.successIcon} />
                                Your email has been verified successfully.
                            </div>
                        </div>
                    )}
                    {!success && (
                        <div className={styles.message}>
                            <div>
                                <CancelIcon className={styles.failedIcon} />
                                There was some problem while verifying your
                                email.
                            </div>
                            <button onClick={() => resendVerificationEmail()}>
                                Regenerate Verification Link
                            </button>
                        </div>
                    )}
                </>
            )}
            <footer className={styles.footerContainer}>
                © 2021 <b>OneClick</b>, Inc. All rights reserved.
            </footer>
        </div>
    );
};

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, {
    verifyEmail,
    resendVerificationEmail,
})(EmailVerification);
